import { render, staticRenderFns } from "./MailV2TemplatePreview.vue?vue&type=template&id=9c3b6952&scoped=true"
import script from "./MailV2TemplatePreview.vue?vue&type=script&lang=js"
export * from "./MailV2TemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./MailV2TemplatePreview.vue?vue&type=style&index=0&id=9c3b6952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3b6952",
  null
  
)

export default component.exports